<div [ngClass]="isMobile ? 'info-modal' : 'desktop-modal'"
  class="bottom-modal slide-top"
  tabindex="0">

  <app-page-content-header
    (closeButtonClick)="onClose()"
    [showCloseButton]="true"
    title1="shared.additionalInformation">
  </app-page-content-header>

  <div [ngClass]="isMobile ? 'info-text' : 'desktop-info-text'">
    <ng-container *ngTemplateOutlet="modalTemplate"></ng-container>
    @if (modalParagraphs?.length) {
      <div>
        @for (paragraph of modalParagraphs; track paragraph) {
          <p [innerHTML]="paragraph | translate"></p>
        }
      </div>
    }
  </div>
</div>


